const binding = { modules: {}, dataActions: {} };

    (binding.modules['page-wrapper'] = {
        c: () => require('partner/modules/page-wrapper/page-wrapper.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'page-wrapper',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/page-wrapper'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|page-wrapper|page-wrapper'] = {
                c: () => require('partner/modules/page-wrapper/page-wrapper.view.tsx'),
                cn: '__local__-__local__-page-wrapper'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };